import { j as c } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as l } from "../../../../IconBase-CxZyIWw2.js";
const n = i((e, o) => /* @__PURE__ */ c.jsx(
  l,
  {
    ref: o,
    ...e,
    image: (a) => /* @__PURE__ */ c.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...a,
        children: /* @__PURE__ */ c.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M25.92 4.208c-.126.703-.255 1.42-.739 1.904L6.113 25.18c-.484.484-1.202.613-1.904.74-.234.042-.467.084-.689.138a2 2 0 1 0 2.422 2.422c.055-.221.097-.454.139-.688.126-.703.255-1.42.739-1.904L25.888 6.82c.484-.484 1.202-.613 1.904-.74.234-.042.467-.084.689-.138a2 2 0 1 0-2.422-2.422c-.055.222-.097.454-.139.688m-.739 19.904c.484-.483.613-1.201.74-1.904.041-.234.083-.466.138-.688a2 2 0 1 1 2.422 2.422 11 11 0 0 1-.689.138c-.702.127-1.42.256-1.904.74l-1.068 1.068c-.484.483-.613 1.201-.74 1.904a11 11 0 0 1-.138.688 2 2 0 1 1-2.422-2.422c.222-.054.455-.096.689-.138.702-.127 1.42-.256 1.904-.74zM6.82 7.888c-.484.483-.613 1.201-.74 1.904-.042.234-.084.466-.138.688A2 2 0 1 1 3.52 8.058c.222-.054.454-.096.688-.138.703-.127 1.42-.256 1.904-.74L7.18 6.112c.484-.483.613-1.201.74-1.904.042-.234.084-.466.138-.688a2 2 0 1 1 2.422 2.422c-.222.054-.454.096-.688.138-.703.127-1.42.256-1.904.74zm18.361 7.224c.484-.483.613-1.201.74-1.903.041-.235.083-.467.138-.689a2 2 0 1 1 2.422 2.422c-.222.054-.455.096-.689.139-.702.126-1.42.255-1.904.739L15.819 25.888c-.483.484-.612 1.201-.739 1.904-.042.234-.084.467-.138.688a2 2 0 1 1-2.422-2.422c.222-.054.454-.096.689-.138.702-.127 1.42-.256 1.904-.74zm-19.1 3.68c.126-.703.255-1.42.739-1.904L16.888 6.82c.483-.484 1.201-.613 1.904-.74.234-.042.467-.084.688-.138a2 2 0 1 0-2.422-2.422c-.054.221-.096.454-.138.688-.126.702-.255 1.42-.739 1.904L6.113 16.18c-.484.484-1.202.613-1.905.74-.234.042-.466.083-.688.138a2 2 0 1 0 2.422 2.422c.054-.222.096-.454.138-.688",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
n.displayName = "FinelinesIcon";
export {
  n as FinelinesIcon,
  n as default
};
//# sourceMappingURL=index.js.map
